import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import classes from "./VariantDetail.module.css";
import { FaMale } from "react-icons/fa";
import { FaFemale } from "react-icons/fa";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
// import { FiPlusCircle } from "react-icons/fi";
import ImageUploadModal from "../ImageUploadModal/ImageUploadModal";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";

const VariantDetail = () => {
  const { addToast } = useToasts();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [productImages, setProductImages] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [models, setModels] = useState([]);
  const [modelsData, setModelsData] = useState([]);
  const [selectedSide, setSelectedSide] = useState("Left");
  const { authData, storeId } = useSelector((state) => state.loginSlice);
  const [isImageUploadModalOpen, setIsImageUploadModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [imgwidth, setImgWidth] = useState("");

  const [filters, setFilters] = useState({
    bodyType: "",
    company: "",
    gender: "",
    status: "",
  });

  const [filterOptions, setFilterOptions] = useState({
    genderOptions: [],
    bodyTypeOptions: [],
    companyOptions: [],
    statusOptions: [],
  });
  const dispatch = useDispatch();

  const [toggleVisibility, setToggleVisibility] = useState({});

  const fetchProductDetails = async () => {
    try {
      const url = `${endpoint.GET_VARIANT_BY_ID}${id}`;
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        storeId,
        dispatch,
      });
      if (response.data.status === "success") {
        const productData = response.data.data?.variant;
        setProduct(productData);
        const filtersData = response.data.data.dropdownData;
        setFilterOptions({
          genderOptions: filtersData.genderDropdown,
          bodyTypeOptions: filtersData.bodyTypeDropdown,
          companyOptions: filtersData.companyDropdown,
          statusOptions: filtersData.statusDropdown,
        });
        setFilters({
          bodyType: productData?.itranslateBodyTypeId,
          company: productData?.iStoreId,
          gender: productData?.iGenderId,
        });
        const images = response.data.data?.variantImages || [];
        setProductImages(images);
        setSelectedImage(images.length > 0 ? images[0].iProductGalleryId : "");
        setModels(response.data.data?.models);
      }
    } catch (error) {
      console.log("Error fetching product details", error);
    }
  };

  useEffect(() => {
    fetchProductDetails();
  }, [id]);

  const handleFilterChange = async (e) => {
    const { name, value } = e.target;

    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));

    try {
      if (name === "status" && value !== "Select Status") {
        const response = await apiHandler({
          url:
            endpoint.UPDATE_STATUS +
            productImages.find(
              (image) => image.iProductGalleryId === selectedImage
            )?.iProductGalleryId,
          method: "PATCH",
          authToken: authData,
          data: {
            iStatusId: value,
          },
          storeId,
          dispatch,
        });
        if (response.data.status === "success") {
          addToast(response.data.message, {
            appearance: "success",
          });
          fetchProductDetails();
        } else {
          console.error("Failed to update status", response.data.message);
        }
      } else if (name !== "status") {
        const updatePayload = {};
        if (name === "gender") updatePayload.iGenderId = value;
        if (name === "bodyType") updatePayload.iBodyTypeId = value;
        if (name === "company") updatePayload.iStoreId = value;

        const response = await apiHandler({
          url: endpoint.UPDATE_PRODUCT + product.iProductId,
          method: "PUT",
          authToken: authData,
          data: updatePayload,
          storeId,
          dispatch,
        });

        if (response.data.status === "success") {
          addToast(response.data.message, {
            appearance: "success",
          });
          fetchProductDetails();
        }
      }
      if (name === "bodyType") {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    } catch (error) {
      console.error("Error updating product", error);
    }
  };

  const calculatePosition = (
    coOrdinates,
    product,
    newwidth,
    newheight,
    prodHeight,
    prodWidth
  ) => {
    console.log(product);

    if (product.iBodyTypeId === 3) {
      const positions = [];
      const fingerNames = Object.keys(coOrdinates.coordinates).filter(
        (key) => key !== "hand" && key !== "sUUID" && key != "sImageURL"
      );
      console.log(coOrdinates, "coOrdinates");

      fingerNames.forEach((finger) => {
        const fingerData = coOrdinates.coordinates[finger][0];

        if (fingerData) {
          let [leftX, leftY] = fingerData.left;

          leftX = leftX * newwidth;
          leftY = leftY * newheight;

          let [rightX, rightY] = fingerData.right;
          rightX = rightX * newwidth;
          rightY = rightY * newheight;

          let centerX = (leftX + rightX) / 2;
          let centerY = (leftY + rightY) / 2;

          const length = Math.sqrt(
            Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
          );
          const aspectRatio = prodHeight / prodWidth;
          const angle =
            (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

          positions.push({
            left: centerX,
            top: centerY,
            rotationAngle: angle,
            height: length * aspectRatio,
            width: length + length * 0.1,
            leftX,
            leftY,
            rightX,
            rightY,
            centerX,
            centerY,
          });
        }
      });

      return positions;
    } else if (product.iBodyTypeId === 1) {
      if (coOrdinates) {
        let coOrdinates1 = coOrdinates.wrist
          ? coOrdinates.wrist.coordinates[0]
          : coOrdinates.wrist;
        let hand = coOrdinates.wrist
          ? coOrdinates.wrist.hand
          : coOrdinates.hand;

        const aspectRatio = prodHeight / prodWidth;

        const handCooridntaes = coOrdinates.hand;
        let [leftX, leftY] = coOrdinates1.left;
        leftX = leftX * newwidth;
        leftY = leftY * newheight;

        let [rightX, rightY] = coOrdinates1.right;
        rightX = rightX * newwidth;
        rightY = rightY * newheight;

        let centerX = (leftX + rightX) / 2;
        let centerY = (leftY + rightY) / 2;

        const length = Math.sqrt(
          Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
        );
        console.log("aspectRatio", aspectRatio);

        const angle =
          hand === "right"
            ? Math.abs(
                (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI
              )
            : Math.abs(
                (Math.atan2(leftY - rightY, leftX - rightX) * 180) / Math.PI
              );

        return {
          left: centerX,
          top: centerY,
          rotationAngle: angle,
          height: length * aspectRatio,
          width: length + length * 0.1,
          leftX,
          leftY,
          rightX,
          rightY,
          centerX,
          centerY,
        };
      }
    } else if (product.iBodyTypeId === 4) {
      let neckCoordinates = coOrdinates?.neck_coordinates?.neck_wide
        ? coOrdinates?.neck_coordinates?.neck_wide
        : coOrdinates?.neck_mask_wide;
      let [leftX, leftY] = neckCoordinates.left_point;
      leftX = leftX * newwidth;
      leftY = leftY * newheight;

      let [rightX, rightY] = neckCoordinates.right_point;
      rightX = rightX * newwidth;
      rightY = rightY * newheight;

      let centerX = (leftX + rightX) / 2;
      let centerY = (leftY + rightY) / 2;

      const length = Math.sqrt(
        Math.pow(rightX - leftX, 2) + Math.pow(rightY - leftY, 2)
      );

      let angle = (Math.atan2(rightY - leftY, rightX - leftX) * 180) / Math.PI;

      if (Math.abs(angle) < 5) {
        angle = 0;
      }

      return {
        left: centerX - length / 2 - length * 0.1,
        top: centerY - length / 2 - length * 0.1,
        rotationAngle: angle,
        height: length + length * 0.2,
        width: length + length * 0.2,
        leftX,
        leftY,
        rightX,
        rightY,
        centerX,
        centerY,
      };
    } else if (product.iBodyTypeId === 2) {
      let earCoordinates = coOrdinates?.ear_coordinates;
      let positions = [];

      earCoordinates.forEach((earCoord) => {
        if (earCoord) {
          const [earX, earY] = earCoord;
          const x = earX * newwidth;
          const y = earY * newheight;
          let zoomfactor = coOrdinates.zoom_factor;
          const aspectRatio = product?.dProductHeight / product?.dProductWidth;
          const productImageHeight =
            newheight * product?.dProductHeight * zoomfactor;
          console.log(product);

          const productImageWidth =
            (newheight * product?.dProductHeight * zoomfactor) / aspectRatio;
          positions.push({
            left: x,
            top: y,
            height:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageHeight
                : 60,
            width:
              aspectRatio && product?.dProductHeight && zoomfactor
                ? productImageWidth
                : 60,
            leftX: x,
            leftY: y,
          });
        }
      });

      return positions;
    } else {
      console.error("Finger data not found for the current finger.");
    }
  };

  const handleToggleChange = (modelId) => {
    setToggleVisibility((prevToggleVisibility) => ({
      ...prevToggleVisibility,
      [modelId]: !prevToggleVisibility[modelId],
    }));
  };

  useEffect(() => {
    if (selectedImage) {
      setFilters({
        status:
          productImages.find(
            (image) => image.iProductGalleryId === selectedImage
          )?.iStatusId || "Select Status",

        bodyType: filters?.bodyType,
        company: filters?.company,
        gender: filters?.gender,
      });
    }
  }, [selectedImage, productImages]);

  useEffect(() => {
    const loadAllProductModelImages = async () => {
      if (!productImages?.length || !models?.length) return;

      const allResults = await Promise.all(
        productImages.map(async (prod) => {
          const productImageDimensions = await new Promise((resolve) => {
            const img = new Image();
            img.src = prod.sURL;

            img.onload = () => {
              resolve({ width: img.naturalWidth, height: img.naturalHeight });
            };

            img.onerror = () => resolve({ width: 0, height: 0 });
          });

          const loadImages = await Promise.all(
            models.map((model) => {
              return new Promise((resolve) => {
                const coordinates = JSON.parse(model.sCoordinate || "{}");

                if (
                  (product.iBodyTypeId === 1 || product.iBodyTypeId === 3) &&
                  model?.sTag?.toLowerCase() !== selectedSide?.toLowerCase()
                ) {
                  return resolve(null);
                }

                const img = new Image();
                img.src = model.sURL;

                img.onload = () => {
                  const height = img.height;
                  const width = img.width;
                  const newWidth = (500 * width) / height;

                  setImgWidth(newWidth);

                  const position = coordinates
                    ? calculatePosition(
                        coordinates,
                        product,
                        newWidth,
                        500,
                        productImageDimensions.height,
                        productImageDimensions.width
                      )
                    : null;

                  resolve({ ...model, productId: product.id, position });
                };

                img.onerror = () => resolve(null);
              });
            })
          );

          return loadImages.filter((m) => m !== null);
        })
      );

      // Flatten the results and set once
      const flattened = allResults.flat();
      const uniqueByGalleryId = Object.values(
        flattened.reduce((acc, item) => {
          acc[item.iGalleryId] = item;
          return acc;
        }, {})
      );

      setModelsData(uniqueByGalleryId);
    };

    loadAllProductModelImages();
  }, [models, product, selectedSide]);

  const handleSideChange = (e) => {
    setSelectedSide(e.target.value);
  };

  const renderDot = (top, left, color) => (
    <div
      style={{
        position: "absolute",
        backgroundColor: color,
        height: "5px",
        width: "5px",
        borderRadius: "50%",
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 2,
      }}
    ></div>
  );

  const renderPositions = (model, positions, bodyType) => {
    if (bodyType === 2) {
      return positions.map((position) =>
        renderDot(position.leftY, position.leftX, "black")
      );
    }
    if (bodyType === 3) {
      return positions.map((position) => (
        <>
          {renderDot(position.leftY, position.leftX, "orange")}
          {renderDot(position.rightY, position.rightX, "green")}
          {renderDot(position.centerY, position.centerX, "tomato")}
        </>
      ));
    }
    return (
      <>
        {renderDot(model.position.leftY, model.position.leftX, "orange")}
        {renderDot(model.position.rightY, model.position.rightX, "green")}
        {renderDot(model.position.centerY, model.position.centerX, "tomato")}
      </>
    );
  };

  const handleImageUploadModalToggle = () => {
    setIsImageUploadModalOpen(!isImageUploadModalOpen);
  };

  const handleImageUploadSuccess = () => {
    fetchProductDetails();
  };

  return (
    <div className="min-h-screen">
      <div className={classes.topheader}>
        <div className="flex justify-between align-items-center">
          <h1 className={`p-1 ${classes.titlename}`}>Variant</h1>
          <button
            className={`flex items-center p-2 px-3 text-white rounded justify-center`}
            style={{ backgroundColor: "#646af5" }}
            onClick={() => navigate(`/product/${location?.state?.iProductId}`)}
          >
            <MdOutlineKeyboardBackspace /> &nbsp; Go Back
          </button>
        </div>
      </div>

      <div className={classes.middle_main_container}>
        {product && (
          <div
            className={`d-lg-flex d-sm-flex gap-5 ${classes.productdetailFirst}`}
          >
            <div className={classes.productleftsection}>
              <div className={classes.productslidersection}>
                <img
                  src={
                    productImages.find(
                      (image) => image.iProductGalleryId === selectedImage
                    )?.sURL || "Product Image"
                  }
                  alt={
                    productImages.find(
                      (image) => image.iProductGalleryId === selectedImage
                    )?.sTag || "Product Image"
                  }
                  className=""
                />
                <p className="mt-2 text-center text-gray-700 font-semibold">
                  {productImages.find(
                    (image) => image.iProductGalleryId === selectedImage
                  )?.sTag || "Selected Image"}
                </p>
              </div>

              <div className={classes.productsliderthumbnails}>
                <div
                  className={`d-flex align-items-center justify-content-center gap-5 ${classes.productsliderthumbnailsImg}`}
                >
                  {productImages.map((image) => (
                    <div
                      key={image.iProductGalleryId}
                      style={{
                        height: "100px",
                        width: "100px",
                        padding: "5px",
                      }}
                      className={`flex items-center justify-center border rounded-lg cursor-pointer hover:shadow-lg transition-shadow duration-200 ${
                        selectedImage === image.iProductGalleryId
                          ? "!border-blue-500 border-2 shadow-lg"
                          : "!border-gray-300"
                      }`}
                      onClick={() => setSelectedImage(image.iProductGalleryId)}
                    >
                      <img
                        src={image.sURL}
                        alt={image.sTag}
                        className="h-full w-full object-contain rounded-lg"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={classes.productrightsection}>
              <h2 className="text-2xl font-semibold">{product.name}</h2>

              <div className={classes.selectProductColor}>
                <strong>Select Status</strong>
                <ul>
                  {filterOptions.statusOptions?.map((option, idx) => {
                    const isActive = filters.status === option.iStatusId;
                    return (
                      <li
                        className={
                          isActive
                            ? `${classes.item} ${classes.active}`
                            : classes.item
                        }
                        key={idx}
                        onClick={() =>
                          handleFilterChange({
                            target: { name: "status", value: option.iStatusId },
                          })
                        }
                      >
                        <span
                          className={classes.colorDot}
                          style={{
                            background: option.sColor,
                            borderColor: option.sColor,
                          }}
                        ></span>
                        <span className={classes.statusText}>
                          {option.sName}
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>

              <div className={classes.selectproductGender}>
                <strong>Gender</strong>
                <ul>
                  {filterOptions.genderOptions.map((option, idx) => (
                    <li
                      className={
                        filters.gender === option.iGenderId
                          ? classes.active
                          : ""
                      }
                      key={idx}
                      onClick={() =>
                        handleFilterChange({
                          target: { name: "gender", value: option.iGenderId },
                        })
                      }
                    >
                      {option.sName === "Male" ? <FaMale /> : <FaFemale />}
                      {option.sName}
                    </li>
                  ))}
                </ul>
              </div>

              {/* <div className={classes.selectbodycompany}>
                <div>
                  <strong>Select Body Type</strong>
                  <select
                    name="bodyType"
                    value={filters.bodyType}
                    onChange={handleFilterChange}
                    className=""
                  >
                    <option>Select Body Type</option>
                    {filterOptions.bodyTypeOptions.map((option) => (
                      <option
                        key={option.iBodyTypeId}
                        value={option.iBodyTypeId}
                      >
                        {option.sName}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
            </div>
          </div>
        )}

        {modelsData.length ? (
          <div className="bg-white p-6 rounded-lg shadow-lg mb-6 mt-10 h-[700px]">
            <div className="flex items-center justify-between mb-4">
              <div className={classes.renderedText}>Rendered Model Images</div>
              {(product.iBodyTypeId === 1 || product.iBodyTypeId === 3) && (
                <select
                  value={selectedSide}
                  onChange={handleSideChange}
                  className="px-4 py-2 border rounded-md bg-white"
                >
                  <option value="Left">Left</option>
                  <option value="Right">Right</option>
                </select>
              )}
            </div>

            <div className="overflow-x-auto flex space-x-4 h-full">
              {modelsData.map((model, modalIndex) => (
                <div
                  key={modalIndex}
                  className={`bg-gray-300 flex-shrink-0 ${classes.renderedmodelImages}`}
                >
                  <div
                    style={{ padding: "15px" }}
                    className="flex items-center justify-center bg relative bg-[#f4f7fb] shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
                  >
                    <div className="bg-white rounded-xl p-[10px]">
                      <div
                        className="bg-gray-300 flex-shrink-0 "
                        style={{
                          position: "relative",
                          width: imgwidth,
                          height: "500px",
                          // height: "500px",
                        }}
                      >
                        <TransformWrapper
                          minScale={1}
                          maxScale={2}
                          disablePadding
                          centerZoomedOut
                          smooth
                          doubleClick={{ disabled: true }}
                        >
                          <TransformComponent>
                            <img
                              src={model.sURL}
                              alt={`Model ${modalIndex}`}
                              className="h-full w-full"
                            />
                            <div className="absolute top-2 right-2  rounded-full p-2">
                              <div className="relative flex items-center">
                                <input
                                  type="checkbox"
                                  id={`status-switch-${model.iGalleryId}`}
                                  checked={
                                    toggleVisibility[model.iGalleryId] || false
                                  }
                                  onChange={() =>
                                    handleToggleChange(model.iGalleryId)
                                  }
                                  className="sr-only"
                                />
                                <div
                                  className={`w-10 h-6 flex items-center rounded-full p-1 cursor-pointer ${
                                    toggleVisibility[model.iGalleryId]
                                      ? "bg-green-500"
                                      : "bg-gray-400"
                                  }`}
                                  onClick={() =>
                                    handleToggleChange(model.iGalleryId)
                                  }
                                >
                                  <div
                                    className={`w-4 h-4 bg-white rounded-full shadow-md transform ${
                                      toggleVisibility[model.iGalleryId]
                                        ? "translate-x-4"
                                        : "translate-x-0"
                                    }`}
                                  />
                                </div>
                              </div>
                            </div>

                            {model?.position ? (
                              <>
                                {!toggleVisibility[model.iGalleryId] ? (
                                  <>
                                    {product.iBodyTypeId === 2 ? (
                                      <>
                                        {model?.position?.map(
                                          (position, index) => (
                                            <img
                                              key={index}
                                              src={
                                                productImages.find(
                                                  (image) =>
                                                    image.iProductGalleryId ===
                                                    selectedImage
                                                )?.sURL || "Product Image"
                                              }
                                              style={{
                                                position: "absolute",
                                                top: `${position.top}px`,
                                                left: `${position.left}px`,
                                                width: `${position.width}px`,
                                                height: `${position.height}px`,
                                                transform: `translateX(-50%)`,
                                              }}
                                            />
                                          )
                                        )}
                                      </>
                                    ) : product.iBodyTypeId === 3 ? (
                                      <>
                                        {model?.position?.map(
                                          (position, index) => (
                                            <img
                                              key={index}
                                              src={
                                                productImages.find(
                                                  (image) =>
                                                    image.iProductGalleryId ===
                                                    selectedImage
                                                )?.sURL || "Product Image"
                                              }
                                              style={{
                                                position: "absolute",
                                                top: `${position.top}px`,
                                                left: `${position.left}px`,
                                                width: `${position.width}px`,
                                                height: `${position.height}px`,
                                                transform: `translate(-50%, -50%) rotate(${position.rotationAngle}deg)`,
                                              }}
                                            />
                                          )
                                        )}
                                      </>
                                    ) : (
                                      <img
                                        src={
                                          productImages.find(
                                            (image) =>
                                              image.iProductGalleryId ===
                                              selectedImage
                                          )?.sURL || "Product Image"
                                        }
                                        style={{
                                          position: "absolute",
                                          top: `${model?.position.top}px`,
                                          left: `${model?.position.left}px`,
                                          width: `${model?.position.width}px`,
                                          height: `${model?.position.height}px`,
                                          transform: `  ${
                                            product.iBodyTypeId === 4
                                              ? "translateY(50%)"
                                              : product.iBodyTypeId === 1
                                              ? "translate(-50%, -50%)"
                                              : ""
                                          } rotate(${
                                            model?.position.rotationAngle
                                          }deg)`,
                                        }}
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {renderPositions(
                                      model,
                                      model?.position || [],
                                      product.iBodyTypeId
                                    )}
                                  </>
                                )}
                              </>
                            ) : null}
                          </TransformComponent>
                        </TransformWrapper>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
      <ImageUploadModal
        isOpen={isImageUploadModalOpen}
        onClose={handleImageUploadModalToggle}
        onUploadSuccess={handleImageUploadSuccess}
        selectedProduct={selectedProduct}
        isBulk={false}
        type={"variant"}
      />
    </div>
  );
};

export default VariantDetail;
